import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.service-points')
  .factory('servicePointsAPI', ServicePointsAPI);

function ServicePointsAPI(): BringozApi {
  return {
    base: `/servicepoint`,
    infiniteScroll: {
      address: `/servicepoint`,
      cmd: 'GET'
    },
    actions: {
      createServicePoint: {
        address: '',
        cmd: 'POST',
        updateable: true
      },
      deleteServicePoint: {
        address: '{id}',
        cmd: 'DELETE',
        updateable: true
      },
      editServicePoint: {
        address: '{id}',
        cmd: 'PUT',
        updateable: true
      },
      getServicePoint: {
        address: '{id}',
        cmd: 'GET',
        updateable: false
      }
    }
  }
}
